import { useState, useEffect } from 'react';

export type Gender = 'male' | 'female' | null;

export const getChildGender = (): Gender => {
  const profile = localStorage.getItem('calmi_child_profile');
  if (profile) {
    try {
      const parsed = JSON.parse(profile);
      return parsed.gender || null;
    } catch {
      return null;
    }
  }
  return null;
};

export const useGender = () => {
  const [gender, setGender] = useState<Gender>(getChildGender());

  useEffect(() => {
    const handleStorageChange = () => {
      setGender(getChildGender());
    };
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('calmi-child-profile-updated', handleStorageChange as EventListener);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('calmi-child-profile-updated', handleStorageChange as EventListener);
    };
  }, []);

  return { gender, setGender };
};

export const adaptText = (masculine: string, feminine: string, gender: Gender): string => {
  if (gender === 'female') return feminine;
  return masculine;
};
